export const ConfigData = [
  {
    id: "name",
    name: "Campaign Name",
    isShow: true,
    width: "250px",
    filter: true,
  },
  {
    id: "description",
    name: "Campaign Description",
    isShow: true,
    width: "250px",
    filter: true,
  },
  {
    id: "created_on",
    name: "Created On",
    isShow: true,
    width: "160px",
    filter: false,
    format: "date-time"
  },
  {
    id: "button",
    name: "View Detail",
    type: "button",
    isShow: true,
    width: "117px"
    
  },
];

